module.exports = __webpack_public_path__ + "img/search.78cc6405.png";